module.exports = __webpack_public_path__ + "static/wfh-image-39f19dfa6970eed8b1af7a885774e11e.svg";